"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyPasteSummaryCell = copyPasteSummaryCell;
exports.cutPasteSummaryCell = cutPasteSummaryCell;
async function copyPasteSummaryCell(activeUserId, activeBranchId, data) {
    try {
        const url = `/dashboard/${activeUserId}/summary/copy_and_paste?c=${activeBranchId}`;
        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(data)
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
async function cutPasteSummaryCell(activeUserId, activeBranchId, data) {
    try {
        const url = `/dashboard/${activeUserId}/summary/cut_and_paste?c=${activeBranchId}`;
        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(data)
        });
        return response.json();
    }
    catch (err) {
        throw err;
    }
}
